import { createId } from '@/features/chat/chatIds'
import { registerArtifactPayload } from '@/features/documentPreview/artifactPayloadStore.js'
import { buildDemoPayloadForKind } from './generatedArtifactDemoPayloads.js'

export function buildGeneratedArtifactAssistantBlocks(details) {
  const artifactId = createId()
  const artifact = registerArtifactPayload({
    artifactId,
    artifactKind: details.artifactKind,
    fileName: details.fileName,
    description: details.description,
    displayTitle: details.displayTitle,
    payload: buildDemoPayloadForKind(details.artifactKind, details.displayTitle),
  })

  return {
    artifact,
    blocks: [
      { type: 'markdown', content: details.leadLine },
      {
        type: 'fileArtifact',
        fileName: details.fileName,
        description: details.description,
        artifactKind: details.artifactKind,
        artifactId,
      },
    ],
  }
}
